export default __webpack_public_path__ + "static/media/audience-demographics-income-and-ethnicity.png";